import * as Yup from "yup";
import { rupeesToNumber, updateFlexUserPlanIds } from "utlis/utils";
import http from "services/httpService";

export const flexGhiSchema = (value) => {
  const flexGhiSchema = Yup.object().shape({
    // maternity_coverage: Yup.string().required("*Required"),
    disease_wise_limit: Yup.string().required("*Required"),
    utilization_limit_for_parents: Yup.string().required("*Required"),
    waiting_period: Yup.string().required("*Required"),
    corporate_buffer:Yup.string().required("*Required"),
    premium_contribution:Yup.string().required("*Required"),
    co_pay: Yup.string().when([], {
      is: () => value.co_pay, // Check if 'value.co_pay' has a value
      then: Yup.string().required("*Required"),
      otherwise: Yup.string(), // Optional: Define behavior when the condition is not met
    }),    
    // opd_included: Yup.string().required("*Required"),
    room_limit: Yup.string().when([], {
      is: ()=>value.room_limit, 
      then: Yup.string().required("*Required"),
      otherwise: Yup.string(), 
    }),
    sum_insured: Yup.string().when([], {
      is: () => value.sum_insured,
      then: Yup.string().required('*Required'),
      otherwise: Yup.string(),
    }),
    wellness_benefits_options: Yup.string().required("*Required"),
    // metro_normal: Yup.string().when('room_limit', (room_limit, schema) => {
    //   if (room_limit === 'Customise Limit (by metro & Non metro)') {
    //     return schema.required('*Required');
    //   }
    //   return schema;
    // }),
    // metro_icu: Yup.string().when('room_limit', (room_limit, schema) => {
    //   if (room_limit === 'Customise Limit (by metro & Non metro)') {
    //     return schema.required('*Required');
    //   }
    //   return schema;
    // }),
    // non_metro_normal: Yup.string().when('room_limit', (room_limit, schema) => {
    //   if (room_limit === 'Customise Limit (by metro & Non metro)') {
    //     return schema.required('*Required');
    //   }
    //   return schema;
    // }),
    // non_metro_icu: Yup.string().when('room_limit', (room_limit, schema) => {
    //   if (room_limit === 'Customise Limit (by metro & Non metro)') {
    //     return schema.required('*Required');
    //   }
    //   return schema;
    // }),
    
    // metro_normal_delivery: Yup.string().when(['maternity_coverage'], {
    //   is: (maternityCoverage) => maternityCoverage === 'true', // Check if 'maternityCoverage' is 'true' as a string
    //   then: Yup.string().required('*Required'),
    //   otherwise: Yup.string(),
    // }),
    // metro_icu_maternity: Yup.string().when('maternity_coverage', {
    //   is: 'true', // Check if 'maternity_coverage' is 'true' as a string
    //   then: Yup.string().required('*Required'),
    //   otherwise: Yup.string(),
    // }),
    // non_metro_normal_delivery_limit: Yup.string().when('maternity_coverage', {
    //   is: 'true', // Check if 'maternity_coverage' is 'true' as a string
    //   then: Yup.string().required('*Required'),
    //   otherwise: Yup.string(),
    // }),
    // non_metro_icu_limit: Yup.string().when('maternity_coverage', {
    //   is: 'true', // Check if 'maternity_coverage' is 'true' as a string
    //   then: Yup.string().required('*Required'),
    //   otherwise: Yup.string(),
    // }),
    // baby_coverage_limit: Yup.string().when('maternity_coverage', {
    //   is: 'true', // Check if 'maternity_coverage' is 'true' as a string
    //   then: Yup.string().required('*Required'),
    //   otherwise: Yup.string(),
    // }),
    
    // co_pay_condition: Yup.string().when('co_pay', (co_pay, schema) => {
    //   if (co_pay === "For All" || co_pay === 'Only For Parents') {
    //     return schema.required('*Required');
    //   }
    //   return schema;
    // }),
    // opd_limit: Yup.string().when('opd_included', {
    //   is: 'true', 
    //   then: Yup.string().required('*Required'),
    //   otherwise: Yup.string(),
    // }),     
    corporate_buffer_limit: Yup.string().when('corporate_buffer', {
      is: 'true', 
      then: Yup.string().required('*Required'),
      otherwise: Yup.string(),
    }),
  });
  return flexGhiSchema
}


export const attributeInitialValues = {
    maternity_coverage:"",
    utilization_limit_for_parents:"",
    co_pay:"",
    waiting_period:"",
    opd_included:"",
    premium_contribution:"",
    corporate_buffer:"",
    disease_wise_limit:"",
    disease_wise_limit_detail: [{
      disease_name: "",
      disease_eligibility_criteria: "",
      disease_limit: "",
    }],
    room_limit: "",
    sum_insured: "",
    wellness_benefits_options: "",
    metro_normal:"",
    co_pay_condition:"",
    metro_icu:'',
    non_metro_normal:"",
    non_metro_icu:"",
    metro_normal_delivery:"",
    metro_icu_maternity:"",
    non_metro_normal_delivery_limit:"",
    non_metro_icu_limit:"",
    baby_coverage_limit:"",
    opd_limit:"",
    corporate_buffer_limit:"",
    wellness_benefits:[]
  };

export const flexGhiPlanSetup = async (values, loading, dynamicFields) => {
        const previous_payload = JSON.parse(localStorage.getItem('setup_plan_payload'));
        const postDataFormat = {
          maternity_coverage: (dynamicFields && dynamicFields.maternity_coverage)? values && values.maternity_coverage: null,
          ambulance_limit: values && values.ambulance_limit,
          utilization_limit_for_parents:
            values && values.utilization_limit_for_parents,
          // disease_wise_limit: values && values.disease_wise_limit,
          waiting_period: values && values.waiting_period,
          opd_included: (dynamicFields && dynamicFields.opd_included) ? values && values.opd_included : null,
          corporate_buffer: values && values.corporate_buffer,
          premium_contribution: values && values.premium_contribution,
          wellness_benefits_options: values && values.wellness_benefits_options,
          ...(dynamicFields.sum_insured ? { sum_insured: values.sum_insured } : {}),
          ...(dynamicFields.room_limit ? { room_limit: values.room_limit } : {}),
          ...(dynamicFields.co_pay ? { co_pay: values?.co_pay } : {}),
        };
        const optionalFields = {
          ...(dynamicFields.sum_insured ? { sum_insured: values.sum_insured } : {}),
          ...(dynamicFields.room_limit ? { room_limit: values.room_limit } : {}),
          ...(dynamicFields.co_pay ? { co_pay: values?.co_pay } : {}),
        };
      
        if (values.room_limit === "Customise Limit (by metro & Non metro)") {
          const { metro_normal, metro_icu, non_metro_normal, non_metro_icu } = values;
      
          postDataFormat.customized_room_limit = {
            metro: {
              normal: (metro_normal && rupeesToNumber(metro_normal)) || null,
              icu: (metro_icu && rupeesToNumber(metro_icu)) || null,
            },
            non_metro: {
              normal: (non_metro_normal && rupeesToNumber(non_metro_normal)) || null,
              icu: (non_metro_icu && rupeesToNumber(non_metro_icu)) || null,
            },
          };
        }
      
        if (values.maternity_coverage === true) {
          const {
            metro_normal_delivery,
            metro_icu_maternity,
            non_metro_normal_delivery_limit,
            non_metro_icu_limit,
          } = values;
          postDataFormat.maternity_coverage_limit = {
            metro: {
              normal:
                (metro_normal_delivery && rupeesToNumber(metro_normal_delivery)) ||
                null,
              icu: (metro_icu_maternity && rupeesToNumber(metro_icu_maternity)) || null,
            },
            non_metro: {
              normal:
                (non_metro_normal_delivery_limit &&
                  rupeesToNumber(non_metro_normal_delivery_limit)) ||
                null,
              icu: (non_metro_icu_limit && rupeesToNumber(non_metro_icu_limit)) || null,
            },
          };
        }
        if (values.maternity_coverage === true){
          postDataFormat.baby_coverage_limit = (values.baby_coverage_limit) || null
        }
      
        if ((values.disease_wise_limit == "Yes")) {
          const { disease_name, disease_eligibility_criteria, disease_limit } =
            values;
          postDataFormat.disease_wise_limit = {
            name: disease_name || null,
            eligibility_criteria: disease_eligibility_criteria || null,
            limit: (disease_limit && rupeesToNumber(disease_limit)) || null,
          };
        }
      
        if(dynamicFields.co_pay){
          if (values.co_pay !== "No") {
          const { co_pay_condition } = values;
          postDataFormat.co_pay_condition = co_pay_condition;
        }}
      
        if (values.opd_included == true) {
          const { opd_limit } = values;
          postDataFormat.opd_limit = (opd_limit && rupeesToNumber(opd_limit)) || null;
        }
        if(values.corporate_buffer === true){
          const { corporate_buffer_limit } = values;
          postDataFormat.corporate_buffer_limit = ( corporate_buffer_limit && rupeesToNumber(corporate_buffer_limit)) || ''
        }
        if(values.disease_wise_limit === 'Yes'){
          postDataFormat.disease_wise_limit = values.disease_wise_limit_detail
        } else{
          postDataFormat.disease_wise_limit = []
        }
        if(values.wellness_benefits_options === 'Yes'){
          postDataFormat.wellness_benefits = values.wellness_benefits
        }
        const combinedArray = {...postDataFormat, ...previous_payload}
        try {
          let { data } = await http.post("/business/setupplan/", combinedArray);
          updateFlexUserPlanIds(
            "health_insurance",
            data.userplan_id
          )
          localStorage.setItem("flex_userplan_id", data.userplan_id);
          return true;
        } catch (err) {
          throw err;
        }
}